import { ExtendedAreaModels, ExtendedConstructionNumber } from '@bpd-library/utilities';
import { FILTER_NAMES } from '@features/properties/components/property-filter';
import { hasFilterUrl } from '@source/utilities/filters/urls';
import { normalizedTranslateItem, translateItem } from '@source/utilities/hooks';

import { Filters } from './construct-filters';

export const setSunDirectionFilter = async (
    { constructionNumbers }: ExtendedAreaModels,
    filters: Filters,
) => {
    const filterName = FILTER_NAMES.sunDirection;

    const getConstructionNumberSunDirections = (
        constructionNumber: ExtendedConstructionNumber,
    ): string[] => {
        const sunDirections: string[] = [];

        if (constructionNumber.specifications?.sunDirection) {
            sunDirections.push(constructionNumber.specifications.sunDirection);
        }

        constructionNumber.gardens
            ?.map(({ position }) => position)
            .forEach((position) => {
                if (position && !sunDirections.includes(position)) {
                    sunDirections.push(position);
                }
            });

        constructionNumber.outsideSpace
            ?.map(({ position }) => position)
            .forEach((position) => {
                if (position && !sunDirections.includes(position)) {
                    sunDirections.push(position);
                }
            });

        return sunDirections;
    };

    const sunDirections = constructionNumbers.reduce<string[]>((directions, constructionNumber) => {
        const sunDirections = getConstructionNumberSunDirections(constructionNumber);

        sunDirections.forEach((sunDirection) => {
            if (!directions.includes(sunDirection)) directions.push(sunDirection);
        });

        return directions;
    }, []);

    if (sunDirections.length) {
        const translatedDirections: Record<string, string> = {};
        for (const direction of sunDirections) {
            const translated = await normalizedTranslateItem(
                'Filters.SunDirection.Direction-',
                direction,
            );
            translatedDirections[direction] = translated;
        }

        filters[filterName] = {
            expanded: false,
            icon: 'icons-sunrise',
            title: await translateItem('Filters.SunDirection.label'),
            dropdownLabel: await translateItem('Filters.SunDirection.dropdownLabel'),
            filterFunctions: {
                constructionNumber: (constructionNumber, filterInput) => {
                    const sunDirections = getConstructionNumberSunDirections(constructionNumber);
                    return sunDirections.includes(filterInput.value);
                },
                propertyType: () => {
                    // Property types don't have a sunDirection property
                    return false;
                },
                projectPhase: () => {
                    // Project phases don't have a sunDirection property
                    return false;
                },
            },
            filterName,
            hasRangeValues: false,
            filters: {
                type: 'checkbox',
                components: sunDirections.map((direction) => ({
                    id: `${filterName}-${direction}`,
                    label: `${translatedDirections[direction]}`,
                    value: `${direction}`,
                    name: filterName,
                    checked: hasFilterUrl(`${direction}`, filterName),
                    type: 'checkbox',
                })),
            },
        };
    }
};
